import { createAsyncAction } from "typesafe-actions";
import { HomeActionTypes ,MyCertInfo,MyCompany} from "./types";

export interface SwitchCompanyProps {
    params:{cid:string},
    success:()=>void
}

// 获取应用列表
export const fetchAppList = createAsyncAction(
  HomeActionTypes.FETCH_APP_LIST,
  HomeActionTypes.FETCH_APP_LIST_SUCCESS,
  HomeActionTypes.FETCH_APP_LIST_ERROR
)<void, any, string>();

// 切换公司
export const fetchSwitchCompany =createAsyncAction(
    HomeActionTypes.FETCH_SWITCH_COMPANY,
    HomeActionTypes.FETCH_SWITCH_COMPANY_SUCCESS,
    HomeActionTypes.FETCH_SWITCH_COMPANY_ERROR,
)<SwitchCompanyProps,void, string>();

// 获取个人的认证信息
export const fetchPersonalCertInfo = createAsyncAction(
    HomeActionTypes.FETCH_PERSONAL_CERT_INFO,
    HomeActionTypes.FETCH_PERSONAL_CERT_INFO_SUCCESS,
    HomeActionTypes.FETCH_PERSONAL_CERT_INFO_ERROR,
)<void, MyCertInfo, string>();

// 获取登陆用户公司列表
export const fetchPersonalCompanyList = createAsyncAction(
    HomeActionTypes.FETCH_PERSONAL_COMPANY_LIST,
    HomeActionTypes.FETCH_PERSONAL_COMPANY_LIST_SUCCESS,
    HomeActionTypes.FETCH_PERSONAL_COMPANY_LIST_ERROR,
)<void, MyCompany[], string>();

// 更新home模块的state
export const updateHomeState = createAsyncAction(
    HomeActionTypes.UPDATE_HOME_STATE,
    "",
    ""
)<any,any,any>();